import TransporterAnalyticsEvent from "./class.TransporterAnalyticsEvent";
import TransporterAnalyticsItem from "./class.TransporterAnalyticsItem.js";
import TransporterLog from "../class.TransporterLog.js";

const LOGGER = new TransporterLog({
	attributes: {
		name: "TransporterAnalyticsPlaythrough",
		color: "lime",
	},
});

const ALIAS = {
	GET_ID: "transporter_analytics_playthrough_get_id",
	UPDATE: "transporter_analytics_playthrough_update",
};

export default class TransporterAnalyticsPlaythrough extends TransporterAnalyticsEvent {
	/**
	 * @param {object} options
	 * @param {object} options.attributes
	 * @param {number} options.attributes.collection_id
	 * @param {number} options.attributes.document_id
	 * @param {number} options.attributes.version
	 * @param {number} options.attributes.user_id
	 * @param {number} options.attributes.class_id
	 * @param {number} [options.attributes.playthrough_id]
	 */
	constructor(options) {
		super(options);
		this.initialize();
	}

	initialize() {
		const error = _.bind(LOGGER.error, LOGGER);
		LOGGER.error = (...n) => {
			if (this.controller.isEnabled()) {
				this.controller.incrementErrorCount();
				error(...n);
			}
		};

		this.items = [];

		if (!_.isNumber(this.playthrough_id)) {
			this.idPromise = this.getId();
		} else {
			this.idPromise = this.getId(true);
		}
	}

	/**
	 * Gets the id for a playthrough.
	 */
	async getId(reserve = false) {
		if (!reserve) {
			if (this.playthrough_id) {
				return this.playthrough_id;
			} else if (this.idPromise) {
				const id = await this.idPromise;
				return id;
			}
		}
		const {collection_id, document_id, version, user_id, class_id} = this;
		try {
			const id = await this.controller.enqueue(ALIAS.GET_ID, {
				collection_id,
				document_id,
				version,
				user_id,
				class_id,
				id: reserve ? this.playthrough_id : undefined,
				force_new: this.controller.forceNewPlaythrough ? true : false,
			});
			this.playthrough_id = id;
			return id;
		} catch (e) {
			LOGGER.error(e);
			return null;
		}
	}

	async update(obj) {
		try {
			await this.controller.enqueue(ALIAS.UPDATE, {
				id: async () => {
					const id = await this.getId();
					return id;
				},
				...obj,
			});
			for (let key in obj) {
				this[key] = obj[key];
			}
		} catch (e) {
			LOGGER.error(e);
		}
	}

	createItem(options) {
		try {
			const item = new TransporterAnalyticsItem({
				attributes: {
					controller: this.controller,
					...options,
					playthrough: this,
				},
			});
			this.items.push(item);
			return item;
		} catch (e) {
			LOGGER.error(e);
			return null;
		}
	}

	async setCompleted() {
		if (!this.completed_at) {
			try {
				await this.update({
					completed_at: Math.floor(Date.now() / 1000),
				});
			} catch (e) {
				LOGGER.error(e);
			}
		}
	}

	async setStartedOver() {
		try {
			await this.update({
				started_over_at: Math.floor(Date.now() / 1000),
			});
		} catch (e) {
			LOGGER.error(e);
		}
	}

	static get ALIAS() {
		return ALIAS;
	}
}
